import { APP_INITIALIZER, Injector, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { StaticModule } from './static/static.module';
import { AppService } from '@services/app.service';
import { StoreService } from '@services/store.service';
import { DatePipe, registerLocaleData } from '@angular/common';
import { DefaultInterceptorService } from './core/interceptors/default-interceptor.service';
import { appInitFactory } from '@factories/app-init.factory';
import { authInitFactory } from '@factories/auth-init.factory';
import { environment } from '@env/environment';
import localeES from '@angular/common/locales/es';
import localePT from '@angular/common/locales/pt';
import localeEL from '@angular/common/locales/el';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { PrivateModule } from './private/private.module';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json?v=' + environment.version);
}

registerLocaleData(localeES);
registerLocaleData(localePT);
registerLocaleData(localeEL);

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserAnimationsModule,
        BrowserModule,
        // External modules
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
        // SVG Module
        AngularSvgIconModule.forRoot(),
        AppRoutingModule,
        // Internal modules
        CoreModule,
        SharedModule,
        StaticModule,
        PrivateModule], providers: [
        {
            provide: LOCALE_ID,
            useValue: 'es-ES',
        },
        // External modules
        {
            provide: APP_INITIALIZER,
            useFactory: appInitFactory,
            deps: [TranslateService, Injector],
            multi: true,
        },
        {
            provide: APP_INITIALIZER,
            useFactory: authInitFactory,
            deps: [Injector],
            multi: true,
        },
        // Services
        AppService,
        StoreService,
        // Pipes
        DatePipe,
        // Guards
        // Interceptors
        {
            provide: HTTP_INTERCEPTORS,
            useClass: DefaultInterceptorService,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
